import { usePageTracking } from '@/hooks/usePageTracking';

/**
 * Global page tracking component that automatically tracks all route changes.
 * This component doesn't render anything - it just sets up the tracking hook.
 */
const PageTracker = () => {
  usePageTracking();
  return null;
};

export default PageTracker;
